import React from "react";
import "../assets/styles/QuickActions.css"; // adjust path as needed

/**
 * QuickActions
 * – Desktop: vertical sticky sidebar (slides in on hover, icon-only at rest)
 * – Mobile:  fixed bottom bar (WhatsApp + Enquire Now)
 * – Global:  floating phone call button (above mobile bar)
 */
function QuickActions() {
  return (
    <>
      {/* ── Floating Call Button (all viewports) ── */}
      <a
        href="tel:+918830308668"
        className="floating-call"
        aria-label="Call us"
      >
        <i className="fa fa-phone" aria-hidden="true"></i>
      </a>

      {/* ── Desktop Sticky Sidebar ── */}
      <nav className="quick-actions-desktop" aria-label="Quick actions">
        <a
          href="https://wa.me/918830308668"
          target="_blank"
          rel="noopener noreferrer"
          className="quick-btn whatsapp"
          aria-label="Chat on WhatsApp"
        >
          <i className="fab fa-whatsapp" aria-hidden="true"></i>
          <span>WhatsApp</span>
        </a>

        <a
          href="#contact"
          className="quick-btn enquire"
          aria-label="Send an enquiry"
        >
          <i className="fa fa-envelope" aria-hidden="true"></i>
          <span>Enquire</span>
        </a>
      </nav>

      {/* ── Mobile Bottom Bar ── */}
      <nav className="quick-actions-mobile" aria-label="Quick actions">
        <a
          href="https://wa.me/918830308668"
          target="_blank"
          rel="noopener noreferrer"
          className="quick-mobile whatsapp"
          aria-label="Chat on WhatsApp"
        >
          <i className="fab fa-whatsapp" aria-hidden="true"></i>
          WhatsApp
        </a>

        <a
          href="#contact"
          className="quick-mobile enquire"
          aria-label="Enquire now"
        >
          <i className="fa fa-envelope" aria-hidden="true"></i>
          Enquire Now
        </a>
      </nav>
    </>
  );
}

export default QuickActions;
